<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-credit-card"></i>
      Wydaj kartę lojalnościową
    </div>
    <div class="card-body">
      <form @submit.prevent="addNewCard()">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="cardNumber">Numer karty</label>
            <input class="form-control" id="cardNumber" v-model="cardNumber" type="text"/>
          </div>
          <div class="form-group col-md-4">
            <label for="cardType">Grupa</label>
            <select class="form-control" id="cardType" v-model="cardType">
              <option value="10">{{ $t('loyaltyCards.level.10')}}</option>
              <option value="20">{{ $t('loyaltyCards.level.20')}}</option>
              <option value="30">{{ $t('loyaltyCards.level.30')}}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <button type="submit" class="btn btn-primary">Wydaj kartę</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import loyaltyCards from '@Service/loyaltyCards';
  import { toastSuccess, toastError } from '../helpers';

  export default {
    props: ['client'],
    data() {
      return {
        cardType: '',
        cardNumber: '',
      };
    },
    mounted() {
      this.cardType = this.client.applicableLoyaltyGroup;
    },
    methods: {
      addNewCard() {
        if (this.cardNumber.length < 1) {
          return;
        }
        loyaltyCards
          .addLoylatyCard({
            cardType: parseInt(this.cardType, 10),
            cardNumber: this.cardNumber,
            clientId: this.client.clientId,
          })
          .then(() => {
            this.cardNumber = '';
            this.$emit('loyalty-cards-updated');
            toastSuccess(this.$t('messages.loayalty-card-add.success'));
          })
          .catch(toastError);
      },
    },
  };
</script>
